// Shared transformation logic
const transformGraphqlProduct = (productNode) => {
  if (!productNode) return null;

  return {
    ...productNode,
    id: parseInt(productNode.id.replace('gid://shopify/Product/', '')),
    price: Math.round(parseFloat(productNode.priceRange.minVariantPrice.amount) * 100),
    compare_at_price: productNode.compareAtPriceRange?.minVariantPrice?.amount ? 
      Math.round(parseFloat(productNode.compareAtPriceRange.minVariantPrice.amount) * 100) : null,
    featured_media: productNode.featuredImage ? {
      preview_image: {
        src: productNode.featuredImage.url,
        alt: productNode.featuredImage.altText || productNode.title
      }
    } : null,
    media: productNode.images?.edges ?
      productNode.images.edges.map(edge => {
        const image = edge.node;
        return {
          alt: image?.altText ? image.altText : productNode.title,
          media_type: 'image',
          src: image?.url ? image.url : null,
          width: image?.width || null,
          height: image?.height || null
        };
      })
      : [],
    url: window.arcLocalizeUrl ? window.arcLocalizeUrl(`/products/${productNode.handle}`) : `/products/${productNode.handle}`,
    available: productNode.variants?.edges?.some(edge => edge.node.availableForSale) || false
  };
};

export default {
  name: 'transformGraphqlProduct',
  magic: (el, { Alpine }) => {
    return transformGraphqlProduct;
  }
}

// Export the shared function for use in other magic functions
export { transformGraphqlProduct };
